import React, { FC } from 'react'
import { IInputProps } from '../../../modules/form'
import { ClassNames } from '../../../modules/utils'
import { Icon } from '../../icon'

interface Props extends IInputProps {
    options: { label: string, value: any }[],
    gender?: string,
}

export const InputSelectTag: FC<Props> = ({ onChange, value, options, gender }) => {
    return (
        <div className="InputSelectTag">
            {options.map((item, key) => {
                const active = value === item.value
                return gender === 'male' ? (
                    <div
                        key={key}
                        className={ClassNames({ item: true, active }) } 
                        onClick={() => onChange(item.value)}
                    >
                        {active ? <Icon.Male /> : null}
                        {item.label}
                    </div>
                ) : gender === 'female' ? (
                    <div
                        key={key}
                        className={ClassNames({ item: true, active }) }
                         onClick={() => onChange(item.value)}
                    >
                        {active ? <Icon.Female/> : null}
                        {item.label}
                    </div>
                ) : (
                    <div
                        key={key}
                        className={ClassNames({ item: true, active })}
                        onClick={() => onChange(item.value)}
                    >
                        {active ? <Icon.Checked /> : null}
                        {item.label}
                    </div>
                )
            })}
        </div>
    )
}